import type { DockZone } from './layout';

/** Where a window shows: a zone, floating or maximized. */
export type Placement = DockZone | 'floating' | 'maximized';

export const tabId = (id: string) => `tool-window-tab-${id}`;
export const panelId = (id: string) => `tool-window-panel-${id}`;
export const titleId = (id: string) => `tool-window-title-${id}`;
export const zoneId = (zone: DockZone) => `dock-zone-${zone}`;
